import React from "react";
import styled from "styled-components";
import howItWork from "../assets/howitwork.svg";
import {
  AppDownload,
  Footer,
  Header,
  HwtSlider1,
  HwtSlider2,
  HwtSlider3,
} from "../components";
import data from "../data/rushdata.json";

const HWork = () => {
  return (
    <>
      <Header />
      <Wrapper
        style={{ background: " #e5edfc", width: "100%", height: "620.55px" }}
      >
        <div className="section-center section text-center hwt">
          <div className="individuals__row">
            <h1>How it works</h1>

            <p>Understand how wecanrush works in 3 simple steps.</p>
          </div>

          {data.hwt.map(({ id, hwtHeadImg }) => (
            <div className="hwt_img_wrapper" key={id}>
              <img className="hwt_img" src={howItWork} alt="how it work" />
            </div>
          ))}
        </div>

        <div className="svgPath">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>

        {/* slider1 */}

        <div className="section-center section text-center hwt__slider sliderOne">
          <HwtSlider1 />
          <div className="hwt__content1">
            <h1>Create your order</h1>
            <p>
              Visit the wecanrush website or download our mobile app from the
              app store, or playstore, sign into your free account and a create
              your order by carefully providing the information requiredin your
              order form.
            </p>
          </div>
        </div>

        {/* slider2  */}
        <div className="hwt__slider sliderTwo">
          <div className="section-center section text-center hwt__slider slider2">
            <div className="hwt__content1 mediaText important">
              <h1 className="getHeaderText">Get Matched</h1>
              <p>
                Wait for our proprietary matching algorithm to match your order
                to an available driver nearby, this usually take between 30
                seconds to 5 minutes.
              </p>
            </div>
            <HwtSlider2 />
          </div>
        </div>

        {/* slider3  */}

        <div className="section-center section text-center hwt__slider slider3">
          <HwtSlider3 />
          <div className="hwt__content1">
            <h1>Track & Receive</h1>
            <p>
              Hand over the item to the driver after proper identitfication. On
              the wecanrush platform, you can track your order using real time
              map tracking until your order is delivered.
            </p>
          </div>
        </div>

        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  .sliderTwo {
    background: #e9f9ff;
  }
  @media screen and (max-width: 440px) {
    .svgPath {
      padding: 128px 0 0 0 !important;
    }
    .section-center.section.text-center.hwt__slider.slider2 {
      display: flex;
      flex-direction: column;
      background-color: #e9f9ff;
    }
    .individuals__row {
      margin-top: 150px;
      /* width: 100%; */
      margin: 20px;
      h1 {
        font-family: Gilroy !important;
        font-size: 36px !important;
        line-height: 50px !important;
        text-align: left !important;
        color: #6300ff;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 30px;
        text-align: left !important;
        color: #777e91;
        margin-top: 20px !important;
        width: 360px !important;
      }
    }
    .hwt_img_wrapper {
      position: absolute;
      width: 100%;
      height: 390px;
      top: 380px !important;
      left: 0;
      overflow-x: hidden;
      .hwt_img {
        width: 100%;
        height: 393px !important;
        object-fit: cover;
        border-radius: 40px !important;
        padding: 20px;
        margin-top: 75px !important;
      }
    }
    .hwt__slider {
      position: relative;
      top: 30% !important;
      align-items: center;
      display: flex;
      flex-direction: column-reverse;
      width: 100%;
      .hwt__content1 {
        width: 100%;
        margin-left: 0px;
        text-align: left;
        margin-top: -140px;
        padding: 20px 20px 20px 30px;
        h1 {
          font-family: Gilroy-Heavy;
          font-size: 30px;
          line-height: 46px;
          color: #6300ff;
          width: 96%;
          height: 46px;
          margin: 20px 0 !important;
          padding: 42px 0 42px 0px !important;
        }
        p {
          font-family: Manrope;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 28px;
          color: #545777;
          width: 100% !important;
          margin-top: 0;
          height: 120px;
        }
      }
    }
    .hwt__content1.mediaText.important {
      text-align: left !important;
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        width: 100% !important;
        margin: 0px 0 0px 0 !important;
        height: 120px;
      }
    }
    .getHeaderText {
      padding: 42px 0 42px 0px !important;
      margin: 0 !important;
    }
  }
  @media screen and (max-width: 768px) {
    .section-center.section.text-center.hwt__slider.slider2 {
      background-color: #e9f9ff;
    }
    .getHeaderText {
      padding: 42px 0 42px 77px !important;
    }
    .hwt_img_wrapper {
      width: 100%;
      .hwt_img {
        width: 100%;
        padding: 20px;
      }
    }
    .hwt__slider {
      position: relative;
      top: 50%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: flex;
      align-content: center;
      justify-content: center;
      .hwt__content1 {
        width: 100%;
        margin-left: 0px;
        text-align: left;
        margin-top: 0px;
      }
    }
    .hwt__content1.mediaText {
      text-align: right !important;
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        width: 83%;
        margin: 40px 0 40px auto;
        height: 120px;
      }
    }
  }

  .hwt {
    position: relative;
  }
  .hwt_img_wrapper {
    position: absolute;
    width: 100%;
    height: 600px;
    top: 520px;
    left: 0;
    overflow: hidden;
    border-radius: 25px !important;
    .hwt_img {
      width: 100%;
    }
  }
  .svgPath {
    padding-top: 100px;
  }

  .individuals__row {
    margin-top: 150px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 66px;
      line-height: 76px;
      text-align: center;
      color: #6300ff;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 17px;
      line-height: 30px;
      text-align: center;
      color: #777e91;
      margin-top: 40px;
    }
  }

  .hwt__slider {
    position: relative;
    top: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .hwt__content1 {
    width: 100%;
    margin-left: 0px;
    text-align: left;
    margin-top: -140px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 36px;
      line-height: 46px;
      color: #6300ff;
      width: 472px;
      height: 46px;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      width: 83%;
      margin-top: 40px;
      height: 120px;
    }
  }

  .slider3 {
    padding-bottom: 270px;
  }
`;

export default HWork;
